export function MissionIcon({ className, color = 'black' }) {
  return (
    <svg width="38" className={className} height="33" viewBox="0 0 38 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29 32C29 28.5758 24.5228 25.8 19 25.8C13.4772 25.8 9 28.5758 9 32M37 25.8008C37 23.2584 34.5318 21.0734 31 20.1167M1 25.8008C1 23.2584 3.46819 21.0734 7 20.1167M31 11.8213C32.2275 10.686 33 9.03623 33 7.2C33 3.77583 30.3137 1 27 1C25.4633 1 24.0615 1.59696 23 2.57871M7 11.8213C5.7725 10.686 5 9.03623 5 7.2C5 3.77583 7.68629 1 11 1C12.5367 1 13.9385 1.59696 15 2.57871M19 19.6C15.6863 19.6 13 16.8242 13 13.4C13 9.97583 15.6863 7.2 19 7.2C22.3137 7.2 25 9.97583 25 13.4C25 16.8242 22.3137 19.6 19 19.6Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
